import { IDepartmentCreate, IDepartmentDetails, IDepartmentListSearch, IEditDepartmentPayload, IGetDepartmentList } from "../../../types/master/departmentInterface";
import { DepartmentActionTypes, DepartmentActions } from "../../actionTypes/master/departmentActionTypes";

export const createDepartment = (payload: IDepartmentCreate): DepartmentActionTypes => ({
  type: DepartmentActions.CREATE_DEPARTMENT,
  payload,
});

export const getDepartmentList = (payload: IDepartmentListSearch): DepartmentActionTypes => ({
  type: DepartmentActions.GET_DEPARTMENT_LIST,
  payload,
});

export const setDepartmentList = (branchList: Array<IGetDepartmentList>) : DepartmentActionTypes => ({
  type: DepartmentActions.SET_DEPARTMENT_LIST,
  payload: branchList
})

export const setDepartmentListPageCount = (payload:number): DepartmentActionTypes => ({
  type: DepartmentActions.SET_DEPARTMENT_LIST_PAGE_COUNT,
  payload
})

export const getDepartmentDataById = (id: number): DepartmentActionTypes => ({
  type: DepartmentActions.GET_DEPARTMENT_DATA_BY_ID,
  payload: id
})

export const setDepartmentDataById = (payload: IDepartmentDetails) => ({
  type: DepartmentActions.SET_DEPARTMENT_DATA_BY_ID,
  payload
})

export const editDepartment = (payload: IEditDepartmentPayload) => ({
  type: DepartmentActions.EDIT_DEPARTMENT_DATA_BY_ID,
  payload,
});
